(function () {
  'use strict';

  var config = window.GiftProgressConfig;
  if (!config) return;

  var FREE_SHIPPING_CENTS = config.freeShipping;

  // Inject shimmer keyframe once so it's always available
  if (!document.getElementById('gp-style')) {
    var s = document.createElement('style');
    s.id = 'gp-style';
    s.textContent =
      '@keyframes gp-shimmer{' +
        '0%{transform:translateX(-250%)}' +
        '100%{transform:translateX(400%)}' +
      '}' +
      '.gift-progress__message strong{font-weight:700;color:#1a1a1a;}';
    document.head.appendChild(s);
  }

  function formatDollars(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function renderProgressBar(container, cartTotalCents, isPage) {
    var pct = Math.min((cartTotalCents / FREE_SHIPPING_CENTS) * 100, 100);
    var message;

    if (cartTotalCents >= FREE_SHIPPING_CENTS) {
      message = "You've unlocked <strong>free shipping!</strong> &#x1F69A;";
    } else {
      var remaining = FREE_SHIPPING_CENTS - cartTotalCents;
      message = 'Spend <strong>' + formatDollars(remaining) + '</strong> more for free shipping';
    }

    // All styles inline — immune to CSS caching
    var wrapPad = isPage
      ? 'padding:16px 0 14px;border-top:1px solid #ebebeb;margin-bottom:4px;'
      : 'padding:20px 16px 14px;border-bottom:1px solid #f0f0f0;';

    container.innerHTML =
      '<div style="' + wrapPad + '">' +
        '<p class="gift-progress__message" style="' +
          'font-size:12px;text-align:center;margin:0 0 10px;' +
          'color:#555;line-height:1.5;letter-spacing:0.02em;">' +
          message +
        '</p>' +
        '<div style="' +
          'height:6px;background:#e8e8e8;border-radius:9999px;' +
          'overflow:hidden;max-width:280px;margin:0 auto;">' +
          '<div id="gp-fill-' + (isPage ? 'page' : 'drawer') + '" style="' +
            'height:100%;border-radius:9999px;background:#f8aba6;' +
            'width:0%;transition:width 0.7s cubic-bezier(0.4,0,0.2,1);' +
            'position:relative;overflow:hidden;">' +
            '<span style="' +
              'position:absolute;top:0;left:0;width:35%;height:100%;' +
              'background:linear-gradient(90deg,transparent,rgba(255,255,255,0.45),transparent);' +
              'animation:gp-shimmer 1.8s ease-in-out infinite;"></span>' +
          '</div>' +
        '</div>' +
      '</div>';

    var fillId = 'gp-fill-' + (isPage ? 'page' : 'drawer');
    var fill = document.getElementById(fillId);
    setTimeout(function () {
      if (fill && document.contains(fill)) {
        fill.style.width = pct + '%';
      }
    }, 30);
  }

  function updateAllBars(cartTotalCents) {
    var drawerEl = document.getElementById('drawer-shipping-progress');
    if (drawerEl) renderProgressBar(drawerEl, cartTotalCents, false);

    var pageEl = document.getElementById('page-gift-progress');
    if (pageEl) renderProgressBar(pageEl, cartTotalCents, true);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(function (cart) {
      updateAllBars(cart.total_price);
    });

    document.addEventListener('cart:updated', function (e) {
      updateAllBars(e.detail.total_price);
    });

    if (window.jQuery) {
      jQuery('body').on('ajaxCart.afterCartLoad', function (e, cart) {
        updateAllBars(cart.total_price);
      });
    }
  });

})();
